import get from 'lodash/get'
import { debug } from '@bt-react/libs/Logger'

export default async function getVideoDevices (deviceId = ''): Promise<MediaDeviceInfo[]> {

  let devices: MediaDeviceInfo[] = []

  try {

    devices = await navigator.mediaDevices.enumerateDevices()

  }
  catch (e) {

    debug(get(e, 'message', ''))

  }

  if (get(devices, 'length', 0) === 0) return []

  try {

    return devices.filter(device => {

      if (deviceId !== '') {

        return device.deviceId === deviceId

      }
      else {

        return device.kind === 'videoinput'

      }

    })

  }
  catch (e) {

    return []

  }

}
